import script from "./ViewersEditModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewersEditModal.vue?vue&type=script&setup=true&lang=ts"

import "./ViewersEditModal.vue?vue&type=style&index=0&id=7d2a9b42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d2a9b42"]])

export default __exports__